module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEcSURBVEhL5ZSxSsNQFIZTceoilA6Ogk/Qp/FFhI4OJX2Fbi6O7o1YBAeHTiK4ilPoUlqIRIcO0e/m/oQk19CkaMD6wUdzz/nvOaSFevvJp9DRQe3K/lZ0v70FOlaeG6P7tRfoWH+h8r+3oIzut7egjNr/ecHfIEmSUG+aQS3GAAeK7Q5DrjXXgd57fgnPp3iDkSIZ1F4UK0LjTJkUzmt8wjt8xamiJvugmAM9X7Ei9Lo032ysCPUZXipqFvh4hc8YK2ZyEfYUc6E5UtaB3iOaryZQyYHeuUZ9DxnzFnMbd6G30edHWshBzfyGHY2qhtAR4QkucIW3OE6nWO6xT22ISwzxgtqhRjSHy8dmsjhR+edg6IGdvfd/Bw6e9wVp+XIN+gkwZwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-irrigation/light/24.png
// module id = 2210
// module chunks = 2